import React from "react";

export default function ResendPopup(props) {

    return(
            <div className="grid-x align-center">
                <div className="cell text-center">
                    <h3 className='text-center mar-bot-10'>Invite was sent again!</h3>
                    <p className='popup__text'>
                        An invitation email was resent to {props.email}
                    </p>
                </div>
            </div>
    )

}